import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/GlobalStore";
import { setReservations, setUser } from "../../store/slices/authSlice";
import { useGetMyReservationsQuery } from "../../services/ReservationAPI";
import { useGetMeQuery } from "../../services/UserAPI";

/**
 * Hook qui re-fetche silencieusement les données utilisateur (réservations + profil)
 * à chaque changement de route, sans interaction visible.
 */
export const useRouteRefresh = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authState = useSelector((state: RootState) => state.Auth);

  const email = authState.user?.email;
  const isAuthenticated = !!authState.jwt && !!email;

  const { data: reservationData, refetch: refetchReservations } =
    useGetMyReservationsQuery(undefined, { skip: !isAuthenticated });

  const { data: meData, refetch: refetchMe } = useGetMeQuery(undefined, {
    skip: !isAuthenticated,
  });

  // Re-fetch à chaque changement de route
  useEffect(() => {
    if (!isAuthenticated) return;
    refetchReservations();
    refetchMe();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  // Sync des réservations dans le store Redux dès que RTK Query retourne de nouvelles données
  useEffect(() => {
    if (reservationData) {
      dispatch(setReservations(reservationData));
    }
  }, [reservationData, dispatch]);

  // Sync du profil utilisateur dans le store Redux
  useEffect(() => {
    if (meData) {
      dispatch(setUser(meData));
    }
  }, [meData, dispatch]);
};
